<div class="desktop-view">
  <div class="row-top-msg">
    <img src="../../../../assets/logos/simbol-agenda.svg" />
    <span class="top-msg">
      Aponte a câmera do seu celular para o QR-Code e baixe o App do Agenda+
      para acessar todo o conteúdo disponível.
    </span>
    <button
      mat-dialog-close
      mat-icon-button
      aria-label="Close"
      layout="row"
      layout-align="end"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="qr-code">
    <img
      alt="qr code para lojas"
      src="../../../../assets/images/agenda-store-qr-code.svg"
    />
  </div>
  <div class="qr-code-msg">
    Não tem leitor de QR-code? Escolha abaixo a loja conectada ao seu
    dispositivo e baixe o App do Agenda+ agora mesmo.
  </div>
  <div class="store-buttons">
    <img
      alt="Disponível no Google Play"
      src="../../../../assets/images/play_store_badge.svg"
      class="play-store"
      (click)="goPlayStore()"
    />
    <img
      alt="Baixar na App Store"
      src="../../../../assets/images/apple_store_badge.svg"
      class="apple-store"
      (click)="goAppleStore()"
    />
  </div>
</div>

<div class="mobile-view">
  <div class="dialog-image">
    <img
      class="image"
      src="../../../../assets/images/redirect_to_app_stores.svg"
    />
    <button mat-dialog-close mat-icon-button aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <h2 class="dialog-main-text">Baixe o App</h2>
  <P class="dialog-secondary-text"
    >Para que você tenha acesso a todo o conteúdo disponível, baixe o App do
    Agenda+</P
  >
  <div class="buttons">
    <button
      class="btn-salvar"
      mat-raised-button
      [mat-dialog-close]="true"
      (click)="chooseAppPage()"
    >
      Baixar o App
    </button>
    <button class="btn-clear" mat-raised-button [mat-dialog-close]="false">
      Agora não
    </button>
  </div>
</div>
